import { Box, SpaceBetween, Link } from '@cloudscape-design/components';
import { useNavigate } from 'react-router-dom';
import { ConfigurationObject } from '../../services/configs-api';
import { resolveConfigName, formatOnOff } from './format-utils';

interface QueueDetailProps {
  config: ConfigurationObject;
  allConfigs: ConfigurationObject[];
}

/**
 * Human-readable detail view for Queue config type.
 * Shows: Business Hours Schedule (linked), Holiday Schedule (linked),
 * Emergency Mode (On/Off), Call Recording (On/Off)
 */
export function QueueDetail({ config, allConfigs }: QueueDetailProps) {
  const navigate = useNavigate();
  const payload = config.payload ?? {};

  const bhScheduleId = payload.businessHoursSchedule as string | undefined;
  const holidayScheduleId = payload.holidaySchedule as string | undefined;
  const emergency = formatOnOff(payload.emergencyEnabled);
  const recording = formatOnOff(payload.callRecordingEnabled);

  return (
    <SpaceBetween size="m">
      <div>
        <Box variant="awsui-key-label">Business Hours Schedule</Box>
        {bhScheduleId ? (
          <Link onFollow={(e) => { e.preventDefault(); navigate(`/configs/${bhScheduleId}?type=business-hours`); }}>
            {resolveConfigName(bhScheduleId, allConfigs)}
          </Link>
        ) : (
          <Box color="text-status-inactive">—</Box>
        )}
      </div>

      <div>
        <Box variant="awsui-key-label">Holiday Schedule</Box>
        {holidayScheduleId ? (
          <Link onFollow={(e) => { e.preventDefault(); navigate(`/configs/${holidayScheduleId}?type=holidays`); }}>
            {resolveConfigName(holidayScheduleId, allConfigs)}
          </Link>
        ) : (
          <Box color="text-status-inactive">—</Box>
        )}
      </div>

      <div>
        <Box variant="awsui-key-label">Emergency Mode</Box>
        <span style={{ color: emergency.colour === 'green' ? '#037F0C' : emergency.colour === 'red' ? '#D13212' : '#687078' }}>
          {emergency.text}
        </span>
      </div>

      <div>
        <Box variant="awsui-key-label">Call Recording</Box>
        <span style={{ color: recording.colour === 'green' ? '#037F0C' : recording.colour === 'red' ? '#D13212' : '#687078' }}>
          {recording.text}
        </span>
      </div>
    </SpaceBetween>
  );
}
